import { SupervisedUserCircle } from '@mui/icons-material'
import KampaayerEdit from './KampaayerEdit'
import KampaayerCreate from './KampaayerCreate'
import KampaayerList from './KampaayerList'

const kampaayersIndex = {
  icon: SupervisedUserCircle,
  edit: KampaayerEdit,
  create: KampaayerCreate,
  list: KampaayerList,
}

export default kampaayersIndex
